import React from "react";
import "./styles.scss";

interface IHrProps {
  evenSpacing?: boolean;
}

export const Hr: React.FC<IHrProps> = ({ evenSpacing }) => (
  <div
    className={`calculators-horizontal-line ${
      evenSpacing ? "calculators-horizontal-line--even-spacing" : ""
    }`}
  />
);
